import React, { useState, useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Particles from "react-particles-js";
import { BrowserRouter, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Services from "./components/Services";
import Skills from "./components/Skills";
import Portfolio from "./components/Portfolio";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 6000);
  }, []);
  return (
    <React-Fragment>
      {loading ? (
        <div className="app">
          <ClimbingBoxLoader
            size={50}
            color={"#f9ab00"}
            loading={loading}
            speedMultiplier={1.5}
          />
        </div>
      ) : (
        <React-Fragment>
          <Particles
            params={{
              particles: {
                number: {
                  value: 30,
                  density: {
                    enable: true,
                    value_area: 900,
                  },
                },
                shape: {
                  type: "circle",
                  stroke: {
                    width: 6,
                    color: "#f9ab00",
                  },
                },
              },
            }}
          />
          <BrowserRouter>
            <Navbar />
            <Route exact path="/" />
            <Route path="/contact" component={Contact} />
            <Header />
            <Route path="/contact" component={Contact} />
          </BrowserRouter>
          <Services />
          <Skills />
          <Portfolio />
          <About />
          <Footer />
        </React-Fragment>
      )}
    </React-Fragment>
  );
}

export default App;
